import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'



export const fetchProducts = createAsyncThunk(
    'product/fetchProducts',
    async () => {
        const response = await fetch('https://boiling-temple-62751.herokuapp.com/products')
        const product = await response.json()
        return product
    }
)


export const productSlice = createSlice({
    name: "product",
    initialState: {
        allProducts: [],
        cartList: [],
        search: ''
    },
    reducers: {

        searchInput: (state, action) => {
            state.search = action.payload
        },

        addToCartList: (state, action) => {
            const isIn = state.cartList.find(item => item._id === action.payload)

            if (!isIn) {
                const item = state.allProducts.find(i => i._id === action.payload)
                state.cartList = [...state.cartList, { ...item, qty: 1 }]
            } else {


                const old = state.cartList.filter(item => item._id !== action.payload)
                state.cartList = [{ ...isIn, qty: isIn.qty + 1 }, ...old]
                // state.cartList = state.cartList.map(item => item._id === action.payload && { ...item, qty: item.qty + 1 })

            }



        },
        removeToCartList: (state, action) => {
            state.cartList = state.cartList.filter((items) => items._id !== action.payload)
        }
    },
    extraReducers: (builder) => {

        builder.addCase(fetchProducts.fulfilled, (state, action) => {
            state.allProducts = action.payload
        })

    },
})


export const { searchInput, addToCartList, removeToCartList } = productSlice.actions


export default productSlice.reducer